// Widget CSS
import '@/css/_elementor/widgets/steps_slider.css';

// ..........................................................................................

function initThisCarousel(scopeEl) {
	const slider1 = scopeEl.querySelector('.slider-steps_slider');

	if (!slider1) return;

	new Swiper(slider1, {
		speed: 700,
		loop: true,
		grabCursor: true,
		watchSlidesProgress: true,
		threshold: 1,

		slidesPerView: 1,
		spaceBetween: 16,

		breakpoints: {
			1024: {
				spaceBetween: 24,
			},
		},

		navigation: {
			nextEl: slider1.querySelector('.slider-button-next'),
			prevEl: slider1.querySelector('.slider-button-prev'),
		},
	});
}

// ......

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/steps_slider.default', (scope) => {
		const scopeEl = scope[0];

		// ......................................................

		initThisCarousel(scopeEl);

		//
	});
});
